import { render, staticRenderFns } from "./flugstrecken-vergleich-inlandsfluege.vue?vue&type=template&id=51173188&scoped=true"
import script from "./flugstrecken-vergleich-inlandsfluege.vue?vue&type=script&lang=js"
export * from "./flugstrecken-vergleich-inlandsfluege.vue?vue&type=script&lang=js"
import style0 from "./flugstrecken-vergleich-inlandsfluege.vue?vue&type=style&index=0&id=51173188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51173188",
  null
  
)

export default component.exports